import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllRiskMitigationModes,
  createRiskMitigationMode,
  deleteRiskMitigationMode,
  updateRiskMitigationMode,
} from '../../../services/mitigationRiskService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import Swal from 'sweetalert2';
import './MitigationRisk.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
const MitigationRisk = () => {
  const [mitigationRisk, setMitigationRisk] = useState([]);
  const [query, setQuery] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRiskMitigationModes();
        setMitigationRisk(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('mitigationRisk.name'),
      editable: true,
      placeholder: t('mitigationRisk.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('mitigationRisk.nameEn'),
      editable: true,
      placeholder: t('mitigationRisk.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateRiskMitigationMode(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('mitigationRisk.message.updateSuccess', {
            entity: t('mitigationRisk.mitigationRisk'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.mitigationRiskExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.mitigationRiskExists')],
          },
        ]);
      }
    }
  };
  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createRiskMitigationMode(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('mitigationRisk.message.addSuccess', {
            entity: t('mitigationRisk.mitigationRisk'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.mitigationRiskExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.mitigationRiskExists')],
          },
        ]);
      }
    }
  };
  const onDelete = async (record,form) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRiskMitigationMode'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteRiskMitigationMode(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('mitigationRisk.message.deleteSuccess', {
                  entity: t('mitigationRisk.mitigationRisk'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: `${t('message.errorDelete')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
      });
    });
  };
  const addButton = useRef();
  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('mitigationRisk.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('mitigationRisk.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/risk-mitigation-modes"
        columns={columns}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        query={query}
        queryParamName="name.contains"
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default MitigationRisk;
